export interface DeclarationQuestion {
  id: string;
  question: string;
  plain: string;
}

export interface DeclarationGroup {
  stepId: string;
  title: string;
  intro: string;
  questions: DeclarationQuestion[];
}

export const declarationGroups: DeclarationGroup[] = [
  {
    stepId: 'decl-property',
    title: 'A few questions about this property',
    intro: 'Every borrower answers these. Most people answer “No” to most of them.',
    questions: [
      {
        id: 'A',
        question: 'Will you occupy the property as your primary residence?',
        plain: 'Meaning you’ll live here most of the year, usually moving in within 60 days of closing.',
      },
      {
        id: 'A1',
        question: 'Have you had an ownership interest in another property in the last three years?',
        plain: 'Include any home, condo, or land where your name was on the title — even if you’ve since sold it.',
      },
      {
        id: 'B',
        question:
          'If this is a purchase transaction: Do you have a family relationship or business affiliation with the seller of the property?',
        plain: 'For example, buying from a parent, sibling, or a company you own part of.',
      },
    ],
  },
  {
    stepId: 'decl-transaction',
    title: 'About the money for this purchase',
    intro: 'These help confirm where your funds come from and what other credit you may be opening.',
    questions: [
      {
        id: 'C',
        question:
          'Are you borrowing any money for this real estate transaction (e.g., money for your closing costs or down payment) or obtaining any money from another party, such as the seller or realtor, that you have not disclosed on this loan application?',
        plain: 'Gift funds you’ve already listed in your assets don’t count here.',
      },
      {
        id: 'D1',
        question:
          'Have you or will you be applying for a mortgage loan on another property (not the property securing this loan) on or before closing this transaction that is not disclosed on this loan application?',
        plain: 'For example, buying a second home at the same time.',
      },
      {
        id: 'D2',
        question:
          'Have you or will you be applying for any new credit (e.g., installment loan, credit card, etc.) on or before closing this loan that is not disclosed on this application?',
        plain: 'Like financing furniture or a car before you close. Tip: it’s best to hold off until after closing.',
      },
      {
        id: 'E',
        question:
          'Will this property be subject to a lien that could take priority over the first mortgage lien, such as a clean energy lien paid through your property taxes (e.g., the Property Assessed Clean Energy Program)?',
        plain: 'This usually applies to solar or energy-efficiency financing attached to the home.',
      },
    ],
  },
  {
    stepId: 'decl-history',
    title: 'Your financial history',
    intro: 'Answer honestly — a “Yes” doesn’t automatically disqualify you. {{loanOfficerFirstName}} will talk through anything with you.',
    questions: [
      {
        id: 'F',
        question:
          'Are you a co-signer or guarantor on any debt or loan that is not disclosed on this application?',
        plain: 'For example, co-signing a car loan or student loan for someone else.',
      },
      {
        id: 'G',
        question: 'Are there any outstanding judgments against you?',
        plain: 'A judgment is a court order to pay a debt.',
      },
      {
        id: 'H',
        question: 'Are you currently delinquent or in default on a Federal debt?',
        plain: 'Includes federal student loans, SBA loans, or back taxes owed to the IRS.',
      },
      {
        id: 'I',
        question: 'Are you a party to a lawsuit in which you potentially have any personal financial liability?',
        plain: 'Only lawsuits where you could owe money.',
      },
      {
        id: 'J',
        question: 'Have you conveyed title to any property in lieu of foreclosure in the past 7 years?',
        plain: 'Also called a “deed in lieu” — giving a home back to the lender to avoid foreclosure.',
      },
      {
        id: 'K',
        question:
          'Within the past 7 years, have you completed a pre-foreclosure sale or short sale, whereby the property was sold to a third party and the Lender agreed to accept less than the outstanding mortgage balance due?',
        plain: 'A short sale is selling a home for less than what was owed on the mortgage.',
      },
      {
        id: 'L',
        question: 'Have you had property foreclosed upon in the last 7 years?',
        plain: '',
      },
      {
        id: 'M',
        question: 'Have you declared bankruptcy within the past 7 years?',
        plain: 'Includes Chapter 7, 11, 12, or 13.',
      },
    ],
  },
];
